<template>
  <div class="host vm-userbar-host">
    <div v-if="isAuth">
      <div class="vm-userbar-info" @click="showUserbarMenu">
        <div :style="{ color: primaryColor }" class="vm-name">{{ fullName }}</div>
      </div>
      <transition name="down-fade">
        <div
          v-if="showUserbar"
          class="vm-userbar-menu"
          v-click-outside="hideUserbarMenu"
        >
          <div class="vm-userbar-menu-header">
            <div class="vm-userbar-menu-avatar">
              <img v-if="avatar" :src="avatar" alt="avatar" />
              <span v-else>{{ initials }}</span>
            </div>
            <div>
              <div class="vm-userbar-menu-title">{{ fullName }}</div>
              <div class="vm-userbar-menu-subtitle">{{ userEmail }}</div>
            </div>
          </div>
          <div class="vm-userbar-menu-content">
            <router-link
              @click.native="showUserbar = false"
              class="vm-userbar-menu-button"
              v-for="nav in userNavTree"
              :key="nav.name"
              :to="{ name: nav.name }"
            >
              {{ nav.title }}
            </router-link>
            <router-link
              class="vm-userbar-menu-button"
              @click.native="showUserbar = false"
              :to="{ name: 'index.recordspage' }"
            >
              Мои записи
            </router-link>
            <router-link
              class="vm-userbar-menu-button"
              @click.native="showUserbar = false"
              :to="{ name: 'index.profilepage' }"
            >
              Профиль пользователя
            </router-link>
            <button
              @click="openUploadClinics"
              class="vm-userbar-menu-button"
              v-if="isSuperuser"
            >
              <span >Загрузить данные клиник...</span>
            </button>
            <button
              :disabled="logoutLoading"
              @click="logout"
              class="vm-userbar-menu-button"
            >
              <span v-if="!logoutLoading">Выйти</span>
              <span v-else class="loading-dots">
                Выход
                <span>.</span>
                <span>.</span>
                <span>.</span>
              </span>
            </button>
          </div>
        </div>
      </transition>
    </div>
    <Dialog v-model="showLoginForm" v-else>
      <template #activator="{ on }">
        <button type="button" class="vm-button" @click="on">Войти</button>
      </template>
      <template #default>
        <div class="vm-dialog-form">
          <div v-if="loginLoading" class="vm-dialog-form-overlay"></div>
          <div class="vm-header">
            <span v-if="!loginLoading">Вход</span>
            <span v-else class="loading-dots">
              Вход
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </span>
          </div>
          <div class="vm-content">
            <form class="form-material" @submit.prevent="submit">
              <FormField>
                <input
                  :class="{ invalid: $v.email.$error }"
                  v-model="email"
                  @blur="$v.email.$touch()"
                  type="text"
                  name="email"
                  class="form-control"
                  placeholder="Email"
                />
                <Error v-if="$v.email.$error && !$v.email.required">
                  Поле обязательнное
                </Error>
                <Error v-if="$v.email.$error && !$v.email.email">
                  Некорректный еmail
                </Error>
              </FormField>
              <FormField>
                <input
                  :class="{ invalid: $v.email.$error }"
                  v-model="password"
                  @blur="$v.password.$touch()"
                  type="password"
                  name="password"
                  class="form-control"
                  placeholder="Пароль"
                />
                <Error v-if="$v.password.$error && !$v.password.required">
                  Поле обязательнное
                </Error>
              </FormField>
              <div class="vm-bottom">
                <Dialog v-model="resetDialog">
                  <template #activator> <!--="{ on }"   @click="on"-->
                    <a href="/reset-password" class="vm-forgot-button" type="button">
                      Забыли пароль?
                    </a>
                  </template>
                  <template #default>
                    <div
                      v-if="resetLoading"
                      class="vm-dialog-form-overlay"
                    ></div>
                    <div class="vm-header">
                      <span v-if="!resetLoading">Сброс пароля</span>
                      <span v-else class="loading-dots">
                        Сброс пароля
                        <span>.</span>
                        <span>.</span>
                        <span>.</span>
                      </span>
                    </div>
                    <div class="vm-content">
                      <form
                        class="vm-register-form form-material"
                        @submit.prevent="toReset()"
                      >
                        <div class="form-group email-form-group">
                          <input
                            v-model="resetForm.email"
                            type="text"
                            name="reset-email"
                            class="form-control"
                            placeholder="Email"
                          />
                        </div>
                        <div class="vm-bottom">
                          <button class="vm-submit-button" type="submit">
                            Сбросить
                          </button>
                        </div>
                      </form>
                    </div>
                  </template>
                </Dialog>
                <button
                  :disabled="$v.email.$invalid || $v.password.$invalid"
                  class="vm-submit-button"
                  type="submit"
                >
                  Войти
                </button>
              </div>
            </form>
          </div>
          <Socialist :redirect="$route.params.reverseURL ? $route.params.reverseURL : ''" @google="onSignInSuccess($event)" @facebook="onSignInSuccessFacebook" @error="onSignInError" />
          <div class="vm-footer">
            <Dialog v-model="showSignUpForm" class="register-dialog">
              <!-- @todo сделать как положено -->
              <!-- <template #activator="{ on }">
                <button type="button" class="vm-footer-button" @click="on">
                  Зарегистрироваться
                </button>
              </template> -->
              <template #activator="{  }">
                <b-button to="/register" class="vm-footer-button">
                  Зарегистрироваться
                </b-button>
              </template>
              <template #default>
                <div
                  v-if="registerLoading"
                  class="vm-dialog-form-overlay"
                ></div>
                <div class="vm-header">
                  <span v-if="!loginLoading">Регистрация</span>
                  <span v-else class="loading-dots">
                    Регистрация
                    <span>.</span>
                    <span>.</span>
                    <span>.</span>
                  </span>
                </div>
                <div class="vm-content">
                  <form
                    class="vm-register-form form-material"
                    @submit.prevent="toRegister()"
                  >
                    <div class="form-group">
                      <input
                        v-model="registerForm.firstName"
                        type="text"
                        name="register-first-name"
                        class="form-control"
                        placeholder="Имя"
                      />
                    </div>
                    <div class="form-group">
                      <input
                        v-model="registerForm.lastName"
                        type="text"
                        name="register-last-name"
                        class="form-control"
                        placeholder="Фамилия"
                      />
                    </div>
                    <div class="form-group email-form-group">
                      <input
                        v-model="registerForm.email"
                        type="text"
                        name="register-email"
                        class="form-control"
                        placeholder="Email"
                      />
                    </div>
                    <div class="form-group">
                      <input
                        v-model="registerForm.password"
                        type="password"
                        name="register-password"
                        class="form-control"
                        placeholder="Пароль"
                      />
                    </div>
                    <div class="form-group">
                      <input
                        v-model="registerForm.confirmPassword"
                        type="password"
                        name="register-confirm-password"
                        class="form-control"
                        placeholder="Повторите пароль"
                      />
                    </div>
                    <div class="vm-bottom">
                      <button class="vm-submit-button" type="submit">
                        Зарегистироваться
                      </button>
                    </div>
                  </form>
                </div>
              </template>
            </Dialog>
          </div>
        </div>
      </template>
    </Dialog>
    <Dialog class="success-dialog" v-model="successRegisterDialog">
      <div class="success-dialog-content">
        <h3>Вы успешно зарегистировались</h3>
        <p>
          Пожалуйста, проверьте свою электронную почту, чтобы активировать вашу
          учетную запись
        </p>
      </div>
    </Dialog>
    <Dialog class="success-dialog" v-model="successResetDialog">
      <div class="success-dialog-content">
        <h3>Сброс пароля</h3>
        <p>
          Пожалуйста, проверьте свою электронную почту, чтобы сбросить пароль
        </p>
      </div>
    </Dialog>
    <Dialog v-model="uploadClinics">
      <div style="width:35vw;  padding:1rem;">
        <div style="text-align:center">
          <h4>Загрузить данные клиник...</h4>
          <hr/>
        </div>
        <b-form-group v-if="!uploading" label="Файл:" label-for="file-large" label-cols-sm="2" label-size="lg">
          <b-form-file 
          id="file-large" 
          size="lg"
          v-model="file"
          accept=".xlsx, .csv, .xls"
          @input="upload(file)" 
          placeholder="Выбрать файл..."
          browse-text="Выбрать">

          </b-form-file>
        </b-form-group>
        <div v-else style="text-align:center; width:100%"> <b-spinner variant="primary" label="Text Centered"></b-spinner> </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import ClickOutside from '@app/directives/click-outside.directive';
import axios from 'axios';
import Dialog from '@app/components/uikit/Dialog';
import FormField from '@app/components/uikit/FormField';
import Error from '@app/components/uikit/Error';
import { required, email } from 'vuelidate/lib/validators';
import { laravelHttp, http, refBookHttp, receptionHttp, uploadSitesApi } from '@app/services';
import Socialist from '@app/components/uikit/Socialist.vue';
import { theme } from '@app/theme';


import toastr from 'toastr';
export default {
  components: {
    Dialog,
    FormField,
    Error,
    Socialist
  },
  directives: {
    ClickOutside
  },
  data: () => ({
    email: null,
    password: null,
    showUserbar: false,
    logoutLoading: false,
    loginLoading: false,
    showSignUpForm: false,
    registerLoading: false,
    successRegisterDialog: false,
    successResetDialog: false,
    resetDialog: false,
    resetLoading: false,
    resetForm: {
      email: null
    },
    registerForm: {
      firstName: null,
      lastName: null,
      email: null,
      password: null,
      confirmPassword: null
    },
    ...theme,
    uploadClinics: false,
    file: null,
    uploading: false
  }),
  validations: {
    email: {
      required,
      email
    },
    password: {
      required
    }
  },
  async created() {
    if (!this.isAuth) {
      http.removeToken();
      laravelHttp.removeToken();
      delete axios.defaults.headers.common['Authorization'];
    }
    const urlParams = new URLSearchParams(this.$route.hash);
    const access_token = this.$route.query.code ? this.$route.query.code : urlParams.get('#access_token');
    const isOK = urlParams.get('session_secret_key');
    if (access_token) {
      if (!isOK) {
        if (this.$route.hash === '#_') {
          await this.login('instagram', access_token);
        } else if (urlParams.get('token_type')) {
          await this.login('yandex-oauth2', access_token);
        } else {
          await this.login('vk-oauth2', access_token);
          if (this.$route.query.redirect) {
            this.$router.push({name: 'vuexchatroom', params: {id: this.$route.query.redirect}});
          } else {
            if (!this.$store.state.navigation.site) {
            const clinic = JSON.parse(localStorage.getItem('lastClinic'));
              if (clinic && this.$store.state.permission.resources.organization) {
                const clinicName = clinic.slug ? clinic.slug : clinic.id;
                this.$router.push(`/clinics/${clinicName}/personal-area`);
              } else {
                this.$router.push('/clinics');
              }
            }
          }
        }
      } else {
        await this.login('odnoklassniki-oauth2', access_token);
         if (this.$route.query.redirect) {
          this.$router.push({name: 'vuexchatroom', params: {id: this.$route.query.redirect}});
        } else {
          if (!this.$store.state.navigation.site) {
          const clinic = JSON.parse(localStorage.getItem('lastClinic'));
            if (clinic && this.$store.state.permission.resources.organization) {
              const clinicName = clinic.slug ? clinic.slug : clinic.id;
              this.$router.push(`/clinics/${clinicName}/personal-area`);
            } else {
              this.$router.push('/clinics');
            }
          }
        }
      }
    }
    if (this.$store.state.navigation.site) {
      if (this.$store.state.permission.resources) {
        if (this.$store.state.permission.resources.organization) {
          if (this.$store.state.permission.resources.organization[this.$store.state.clinic.id]) {
            console.log(this.$store.state.permission.resources.organization[this.$store.state.clinic.id].roles);
            this.$store.commit('clinic/setRoles', this.$store.state.permission.resources.organization[this.$store.state.clinic.id].roles);
          }
        }
      }
    }
  },
  mounted() {
    console.log(this.$store.state);
  },
  computed: {
    showLoginForm: {
      get() {
        return this.$store.state.navigation.loginDialog;
      },
      set(value) {
        this.$store.commit('navigation/setLoginDialog', value);
      }
    },
    isAuth() {
      return this.$store.state.auth.is_auth;
    },
    avatar() {
      return this.$store.state.permission.avatar;
    },
    userEmail() {
      return this.$store.getters['auth/getEmail'];
    },
    fullName() {
      return this.$store.state.permission.userName;
    },
    initials() {
      return this.$store.state.permission.userInitials;
    },
    userNavTree() {
      return this.$store.state.navigation.userTree;
    },
    isSuperuser() {
      return this.$store.state.permission.is_superuser;
    }
  },
  methods: {
    async submit() {
      this.loginLoading = true;
      try {
        await this.login();
        this.$store.commit('navigation/setLoginDialog', false);
        if (!this.$store.state.navigation.site) {
          if (this.$route.name !== 'clinic.public') {
            if (this.$route.params.reverseURL) {
              this.$router.push({name: 'vuexchatroom', params: { id: this.$route.params.reverseURL}});
            } else {
              /*const clinic = JSON.parse(localStorage.getItem('lastClinic'));
              if (clinic && this.$store.state.permission.resources.organization) {
                const clinicName = clinic.slug ? clinic.slug : clinic.id;
                this.$router.push(`/clinics/${clinicName}/personal-area`);
              } else {
                this.$router.push('/clinics');
              }*/
            }
          }
        }
      } catch (e) {
        console.error(e);
        helper.showErrorMsg(e);
        toastr.error('Ошибка авторизации');
      }
      this.loginLoading = false;
    },
    async toRegister() {
      this.registerLoading = true;
      this.showSignUpForm = false;
      this.$store.commit('navigation/setLoginDialog', false);
      this.registerLoading = false;
      this.successRegisterDialog = true;
    },
    toReset() {
      this.resetLoading = true;
      this.resetDialog = false;
      this.$store.commit('navigation/setLoginDialog', false);
      this.resetLoading = false;
      this.successResetDialog = true;
    },
    async login(social, token) {
      let data_cur;
      if (!social) {
        const body = { 
          username: this.email, 
          password: this.password,
          grant_type: 'password',
          client_id: 2,
          client_secret: 'WJC4eSpLDGtdtcyh0NfuwCNk6PtCZH1U9vNh0Hu7'
        };
        const { data } = await axios.post('/oauth/token/', body);
        data_cur = data;
      } else {
        const body = { 
          backend: social,
          grant_type: 'convert_token',
          client_id: 2,
          client_secret: 'WJC4eSpLDGtdtcyh0NfuwCNk6PtCZH1U9vNh0Hu7',
          token: token,
          redirect_uri: social === 'instagram' ? window.location.origin + '/' : window.location.origin
        };
        const headers = {Authorization: 'NoAuth'};
        const { data } = await axios.post('/convert-token/', body, {headers});
        data_cur = data;
      } 
      const data = data_cur;
      localStorage.setItem('auth_token', data.access_token);
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.access_token;
      http.setToken(data.access_token);
      laravelHttp.setToken(data.access_token);
      refBookHttp.setToken(data.access_token);
      receptionHttp.setToken(data.access_token);
      await helper.check();
      await this.$store.dispatch('permission/loadPermissions');
      await this.$store.dispatch('auth/setAuthStatus');
      await this.$store.dispatch('auth/setLastActivity');
    },
    async logout() {
      this.logoutLoading = true;
      try {
        // await axios.post('/logout');
        this.$store.dispatch('auth/resetAuthUserDetail');
        this.hideUserbarMenu();
        http.removeToken();
        laravelHttp.removeToken();
        this.$store.commit('permission/removeResources');
        this.$store.commit('permission/setUserName', null);
        this.$store.commit('clinic/setRoles', []);
        this.$router.push('/');
      } catch (e) {
        console.error(e);
      }
      this.logoutLoading = false;
    },
    showUserbarMenu() {
      this.showUserbar = !this.showUserbar;
    },
    hideUserbarMenu() {
      if (this.showUserbarMenu) {
        this.showUserbar = false;
      }
    },
    async onSignInSuccess(googleUser) { console.log(googleUser);
      const profile = googleUser.getBasicProfile();
      let acc_tok;
      Object.keys(googleUser).forEach(obj => {
        if(googleUser[obj].access_token) {
          acc_tok = googleUser[obj].access_token;
        }
      });
      await this.login('google-oauth2', acc_tok);  // раньше вместо 'Bc' был 'xc'
      if (this.$route.params.reverseURL) {
            this.$router.push({name: 'vuexchatroom', params: { id: this.$route.params.reverseURL}});
      } else {
        /*const clinic = JSON.parse(localStorage.getItem('lastClinic'));
            if (clinic && this.$store.state.permission.resources.organization) {
              const clinicName = clinic.slug ? clinic.slug : clinic.id;
              this.$router.push(`/clinics/${clinicName}/personal-area`);
            } else {
                this.$router.push('/clinics');
            }*/
      }
    },
    onSignInSuccessFacebook (response) { console.log(response);
      FB.api('/me', dude => {
        this.login('facebook', response.authResponse.accessToken);
        if (this.$route.params.reverseURL) {
            this.$router.push({name: 'vuexchatroom', params: { id: this.$route.params.reverseURL}});
        } else {
          /*const clinic = JSON.parse(localStorage.getItem('lastClinic'));
            if (clinic && this.$store.state.permission.resources.organization) {
              const clinicName = clinic.slug ? clinic.slug : clinic.id;
              this.$router.push(`/clinics/${clinicName}/personal-area`);
            } else {
                this.$router.push('/clinics');
            }*/
        }
      });
    },
    onSignInError (error) {
      console.log('OH NOES', error);
      toastr.error('Ошибка авторизации');
    },
    openUploadClinics() {
        this.uploadClinics = true;
    },
    upload(file) {
      this.uploading = true;
      const formData = new FormData();
      formData.append('file', file);
      uploadSitesApi.upload(formData).then(res => {
        this.uploadClinics = false;
        this.uploading = false;
        toastr.success('Уcпешно загружено');
      }).catch(error => {
        this.uploadClinics = false;
        this.uploading = false;
        toastr.error('Ошибка загрузки');
      });
    }
  }
};
</script>

<style lang="scss" scoped>

.vm-userbar-host {
  display: flex;
  align-items: center;
  justify-self: stretch;
  background-color: white;
  align-self: stretch;
  padding: 0 24px;
}
.vm-dialog-form {
  min-width: 320px;
  position: relative;
}
.vm-dialog-form-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.5);
}
.vm-button {
  border: 0;
  padding: 6px 12px;
  background-color: transparent;
  text-transform: uppercase;
  border-radius: 3px;
  margin-left: 5px;
  color: #262626;
  font-weight: 500;
  background-color: white;
  outline: none;
}
.vm-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.down-fade-enter-active {
  transition: all 200ms ease;
}
.down-fade-leave-active {
  transition: all 200ms ease;
}
.down-fade-enter,
.down-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
.vm-userbar {
  position: relative;
}
.vm-userbar-info {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.vm-userbar-menu {
  position: absolute;
  background-color: #fff;
  top: 100%;
  right: 0;
  margin-top: 30px;
  border-radius: 3px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  border: 1px solid #dfdfdf;
}
.vm-userbar-menu-content {
  display: flex;
  flex-direction: column;
  margin: 0.5rem;
}
.vm-userbar-menu-content .vm-userbar-menu-button {
  margin-top: 0.5rem;
}
.vm-userbar-menu-content .vm-userbar-menu-button:first-child {
  margin-top: 0;
}
.vm-userbar-menu-button {
  display: block;
  padding: 0.5rem 1rem;
  width: 100%;
  border-radius: 3px;
  border: 0;
  text-align: left;
  color: #262626;
  text-decoration: none;
  outline: none;
  background-color: white;
}
.vm-userbar-menu-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.vm-userbar-menu-header {
  display: flex;
  padding: 1rem;
  border-bottom: 1px solid #dfdfdf;
}
.vm-userbar-menu-avatar {
  width: 50px;
  height: 50px;
  flex: 0 0 50px;
  border-radius: 50%;
  background: #5281c0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: #fff;
  margin-right: 1rem;
  overflow: hidden;
}
.vm-userbar-menu-avatar img {
  max-width: 100%;
  max-height: 100%;
}
.vm-userbar-menu-title {
  white-space: nowrap;
  font-size: 1.2rem;
}
.vm-userbar-menu-subtitle {
  font-size: 0.8rem;
  color: #5f6368;
}
.vm-userbar .vm-avatar {
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  border-radius: 50%;
  background-color: white;
  color: #fff;
  font-weight: bold;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.vm-userbar .vm-avatar img {
  max-width: 100%;
  max-height: 100%;
}
.vm-header {
  color: #fff;
  padding: 2rem;
  font-size: 2rem;
}
.vm-content {
  padding: 2rem;
}
.vm-name {
  color: #963FDD;
  text-align: center;
}
.vm-header {
  background-color: #0077c7;
  color: #fff;
  padding: 2rem;
  font-size: 2rem;
}
.vm-content {
  padding: 2rem;
}
.vm-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.vm-forgot-button {
  border: 0;
  background-color: transparent;
  padding: 0;
  line-height: 1;
  display: inline;
  color: #212121;
  outline: none;
}
.vm-footer .vm-footer-button {
  border: 0;
  width: 100%;
  background-color: #fff;
  border-top: 1px solid #dfdfdf;
  font-size: 12px;
  color: #414141;
  outline: none;
}
@keyframes blink {
  0% {
    opacity: 0.2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}
.loading-dots span {
  animation-name: blink;
  animation-duration: 1.4s;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
}
.loading-dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.loading-dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.vm-userbar-menu-button:disabled {
  background-color: rgba(0, 0, 0, 0.05);
  color: #5f6368;
}
.vm-register-form {
  display: flex;
  max-width: 360px;
  flex-wrap: wrap;
  margin: -0.5rem;
  justify-content: flex-end;
}
.vm-register-form .vm-bottom {
  margin: 0.5rem;
}
.vm-register-form .form-group {
  width: calc(50% - 1rem);
  margin: 0.5rem;
}
.vm-register-form .email-form-group {
  width: 100%;
}
.success-dialog-content {
  padding: 3rem;
}
.success-dialog h3 {
  margin-bottom: 2rem;
  color: #212121;
}
.form-material .form-control.invalid {
  background-image: linear-gradient(#009efb, #009efb), linear-gradient(red, red);
}
.vm-submit-button {
  border: 0;
  border-radius: 3px;
  background-color: #4376c3;
  color: #fff;
  padding: 0.5rem 1rem;
  outline: none;
  transition: opacity 300ms ease;
  opacity: 1;
}
.vm-submit-button:disabled {
  opacity: 0.3;
}


</style>
